import Box from "@mui/material/Box";
import {FC, useEffect, useState} from "react";
import {GradientButton, GradientText} from "./GradientComponents";
import {Tooltip, Typography} from "@mui/material";

interface InstructionSuggestionsProps {
    suggestions: string[];
    isGeneratingSuggestions: boolean;
    suggestionSelected: (suggestion: string) => void;
    generateSuggestions: () => void;
}

const InstructionSuggestions: FC<InstructionSuggestionsProps> = ({
                                                                     suggestions,
                                                                     isGeneratingSuggestions,
                                                                     suggestionSelected,
                                                                     generateSuggestions
                                                                 }) => {
    const [numberOfSuggestions, setNumberOfSuggestions] = useState(5);

    useEffect(() => {
        if (isGeneratingSuggestions) {
            setNumberOfSuggestions(5);
        }
    }, [isGeneratingSuggestions]);
    return (
        <Box>
            {!isGeneratingSuggestions && suggestions && suggestions.slice(0, numberOfSuggestions).map((suggestion, index) => (
                    <GradientButton key={index}
                                    onClick={() => suggestionSelected(suggestion)}
                                    style={{
                                        borderRadius: 8,
                                        height: 32,
                                        whiteSpace: 'nowrap',
                                        maxWidth: '100%',
                                        border: '1px solid E2E8F0',
                                    }}
                                    sx={{mt: 1, mr: 1}}>
                        <Typography variant={"body2"}
                                    style={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                    }}>
                            {suggestion}
                        </Typography>
                    </GradientButton>
                )
            )}
            {
                isGeneratingSuggestions && (
                    <Typography variant={"body2"} sx={{mt: 1, ml: 1}}>Analyzing transcript to generate suggestions
                        ...</Typography>
                )
            }
            {suggestions.length > 0 ? suggestions.length > numberOfSuggestions && (
                <div><GradientButton style={{
                    height: 32,
                    borderRadius: 8
                }}
                                sx={{mt: 1}}
                                gradientBorder={true}
                                onClick={() => setNumberOfSuggestions(numberOfSuggestions + 5)}>
                    <GradientText variant={"body2"}>
                        Show More
                    </GradientText>
                </GradientButton></div>
            ) : !isGeneratingSuggestions && (
                <GradientButton style={{
                    height: 32,
                    borderRadius: 8
                }}
                                sx={{mt: 1}}
                                gradientBorder={true}
                                onClick={() => generateSuggestions()}>
                    <GradientText variant={"body2"}>
                        Generate Suggestions
                    </GradientText>
                </GradientButton>)
            }
        </Box>
    );
};

export default InstructionSuggestions;
